import { CircleCheck } from 'lucide-react';

export type UploadedStepProps = {
  fileDataUrl: string;
  currentLogoUrl: string | null;
  isReplacing: boolean;
  companyName: string;
};

/** Success step: review notice plus current vs updated logo preview. */
export const UploadedStep = ({
  fileDataUrl,
  currentLogoUrl,
  isReplacing,
  companyName,
}: UploadedStepProps) => (
  <>
    <div className="flex items-start gap-3 rounded-2xl border border-emerald-100 bg-emerald-50 p-4">
      <CircleCheck className="mt-0.5 size-4 shrink-0 text-emerald-600" />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium leading-5 text-emerald-600">
          This goes live as soon as you push — no waiting.
        </p>
        <p className="text-sm leading-5 text-emerald-600">
          We double-check every logo later to make sure it's authentic.
        </p>
      </div>
    </div>

    <div className="flex gap-3">
      {isReplacing && currentLogoUrl && (
        <div className="flex flex-1 flex-col gap-4 rounded-2xl bg-secondary p-4">
          <p className="text-xs font-medium text-muted-foreground">Current</p>
          <div className="flex items-center justify-center py-8">
            <div className="flex size-[90px] items-center justify-center rounded-md border border-border bg-background p-3">
              <img
                src={currentLogoUrl}
                alt={`${companyName} current logo`}
                className="max-h-full max-w-full object-contain"
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-1 flex-col gap-4 rounded-2xl bg-indigo-50 p-4">
        <p className="text-xs font-medium text-muted-foreground">Updated</p>
        <div className="flex items-center justify-center py-8">
          <div className="flex size-[90px] items-center justify-center rounded-md border border-border bg-background p-3">
            <img
              src={fileDataUrl}
              alt={`${companyName} new logo`}
              className="max-h-full max-w-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  </>
);
